import React from 'react'
import style from "css/todayReservation.module.css";

import { ReactComponent as LocationIcon } from "asset/calendar/location_outlined.svg";
import { ReactComponent as TimeIcon } from "asset/calendar/time_outlined.svg";

function HotdeskingCard({ schedule, idx, total, type }) {

    const getTimeforHourlySchedule = (startDateTime, endDateTime) => {
        const options = { hour: '2-digit', minute: '2-digit', hour12: false };

        const startTime = new Date(startDateTime).toLocaleTimeString([], options);
        const endTime = new Date(endDateTime).toLocaleTimeString([], options);

        return `${startTime}-${endTime}`;
    }

    function formatDateRange(start, end) {
        const startDate = new Date(start);
        const endDate = new Date(end);

        const format = (date) => {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            const hh = String(date.getHours()).padStart(2, "0");
            const mi = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");

            return `${yyyy}.${mm}.${dd} ${hh}:${mi}`;
        };

        if (startDate.toDateString() === endDate.toDateString()) {
            return `${format(startDate)} - ${format(endDate).split(" ")[1]}`; // 같은 날짜면 시간만 표기
        } else {
            return `${format(startDate)} - ${format(endDate)}`; // 다른 날짜면 전체 표기
        }
    }

    return (
        <div className={style.hotdesking_card_wrapper}>
            <div className={style.hotdesking_card_container}>
                <div className={style.top}>
                    <div className={style.location_name}>
                        {schedule.resource.title}
                    </div>
                    <div className={style.index}>{`${idx}/${total}`}</div>
                </div>
                <div className={style.bottom}>
                    <div className={style.location_info}>
                        <LocationIcon />
                        {schedule.resource.location.title}
                    </div>
                    <div className={style.time}>
                        <TimeIcon />
                        {type === 'Today' ? getTimeforHourlySchedule(schedule.startDttm, schedule.endDttm) : formatDateRange(schedule.startDttm, schedule.endDttm)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HotdeskingCard
